export default __webpack_public_path__ + "static/media/Taste Test.742e465b.png";